module.exports = __webpack_public_path__ + "static/hero-preview-afe6570ab365edbc4320153b7d8a3d86.jpg";